import React, { useState, useEffect } from 'react'
import { Badge, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { Link } from "react-router-dom"
import { providerPrefix } from 'configs/routePrefix'
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from 'store/adminFilter/actions'
import '../style.scss'

const CardItem = ({ index, itemData, Service,history, updateHandler, status, setShouldGetData }) => {
    const [item, setItem] = useState({...itemData})
    const [itemStatus, setItemStatus] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const dispatch = useDispatch()
    const toggle = () => setDropdownOpen(prevState => !prevState)

    const rate = (Number.isInteger(item?.rate/item?.count))?((item?.rate/item?.count)):((item?.rate/item?.count).toFixed(2))

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>{item.id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>
                    <Link to={`${providerPrefix}/Admin-developer/cards/${item.id}`} onClick={()=> {
                            localStorage.setItem('compound_id', item.id)
                            dispatch(appendFilters({compound_id: item.id, compound: {
                            label: item.name ?.en,
                            value: item.id
                        }}))}}>
                        {item.name ?.en}
                    </Link>
                </td>
                <td className='font-size-13'>
                    <Badge className="bgBadge font-size-14 mt-0 m-1"  
                            style={{ background: "#50a5f1",marginTop:"0px !important" }}>
                                {item.area?.name?.en}
                    </Badge>
                </td>
                <td className='font-size-13'> {item?.left_units}</td>
                <td className='font-size-13'>
                    {!isNaN(rate) ? `${rate} %` : '-'}
                </td>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                readOnly={true}
                            />
                        </div>
                    </form>
                </td>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={()=> history?.push(`${providerPrefix}/Admin-developer/compound/${item?.id}`, {compound_id: item?.id})}>View</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            
        </>

    )
}

export default CardItem